import { render, staticRenderFns } from "./TipDialog.vue?vue&type=template&id=b7a44f4a&scoped=true&"
import script from "./TipDialog.vue?vue&type=script&lang=js&"
export * from "./TipDialog.vue?vue&type=script&lang=js&"
import style0 from "./TipDialog.vue?vue&type=style&index=0&id=b7a44f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a44f4a",
  null
  
)

export default component.exports